﻿angular.module('fliptoWeb')
    .controller('IntroCtrl',
        [
            'name', 'slug', 'introType', 'representatives', 'copyToClipboard', '$location', '$timeout', '$window', 'contacts',
            function (name, slug, introType, representatives, copyToClipboard, $location, $timeout, $window, contacts) {

                let vm = this;
                vm.name = name;
                vm.slug = slug;
                vm.hotelName = slug.replace(/-/gi, " ");

                vm.names = contacts.names;
                vm.emails = contacts.emails;

                vm.getCopyLink = () => {
                    if (!introType) return `http://intro.flip.to/by/${this.name}`;
                    return `http://intro.flip.to/${introType}/by/${this.name}`;
                };

                vm.shareMessageArtifacts = {
                    subject: encodeURIComponent("A marketing platform to check out"),
                    salesBody: encodeURIComponent(`I've been exploring a platform called Flip.to that can help boost our marketing efforts. It uses advocacy to let guests introduce our brand to travelers around the world. And a host of built-in features help to communicate and engage new leads to convert. Very interesting stuff.

${vm.getCopyLink()}

Let's have a conversation about it when you have a chance to take a look.`),
                    amsBody: encodeURIComponent(`We're using a new platform called Flip.to that can help boost our marketing efforts. It uses advocacy to let guests introduce our brand to travelers around the world. And a host of built-in features help to communicate and engage new leads to convert. Very interesting stuff.

${vm.getCopyLink()}

Let's have a conversation about it when you have a chance to take a look.`)
                };
                
                if (!representatives.canRepresent(vm.name)) {
                    let fallbackGuy = representatives.getFallback(vm.name);
                    let newPath = (!!introType ? '/' + introType : '') + '/by/' + fallbackGuy;
                    if (!!vm.slug) {
                        newPath += '/' + vm.slug;
                    }
                    $location.path(newPath);
                }

            }
        ]
    );
